module.exports = __webpack_public_path__ + "img/home_image_2-mobile-fr.da55f1d8.png";